/**
 * The route table. Seven routes, and every one of them is behind the claim.
 *
 * `/signin` is the only thing outside `RequireAdmin`, because signing in is how you get a
 * token to have a claim on. There is no `_kit` here — the kit is the Studio's spec sheet for
 * the design system, and this app is a consumer of it, not a second copy.
 */

import type { RouteObject } from 'react-router';
import { Navigate } from 'react-router';

import { RequireAdmin } from '../auth/RequireAdmin.js';
import { SignIn } from '../auth/SignIn.js';
import { CatalogList } from '../catalog/CatalogList.js';
import { MediumDetail } from '../catalog/MediumDetail.js';
import { GlobalDetail } from '../globals/GlobalDetail.js';
import { GlobalsList } from '../globals/GlobalsList.js';
import { IssueDetail } from '../issues/IssueDetail.js';
import { IssuesList } from '../issues/IssuesList.js';
import { NotFound } from './NotFound.js';

export const routes: RouteObject[] = [
  { path: '/signin', element: <SignIn /> },

  {
    path: '/',
    element: <RequireAdmin />,
    children: [
      { index: true, element: <Navigate to="/mediums" replace /> },

      { path: 'mediums', element: <CatalogList /> },
      { path: 'mediums/:id', element: <MediumDetail /> },

      { path: 'globals', element: <GlobalsList /> },
      { path: 'globals/:id', element: <GlobalDetail /> },

      { path: 'issues', element: <IssuesList /> },
      { path: 'issues/:id', element: <IssueDetail /> },

      { path: '*', element: <NotFound /> },
    ],
  },
];
